import { useCbhFlag } from "@src/appV2/FeatureFlags";
import { CbhFeatureFlag } from "@src/appV2/FeatureFlags/CbhFeatureFlag";

export function useHelloSignFallbackUrl() {
  return useCbhFlag(CbhFeatureFlag.USE_HELLOSIGN_FALLBACK_URL, { defaultValue: false });
}
